import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
  className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
  page,
  totalPages,
  onPageChange,
  loading = false,
  className = '',
}) => {
  if (totalPages < 1) return null;

  return (
    <div
      className={`flex items-center justify-between border-t border-[#252a38] bg-[#10131a] px-5 py-3 ${className}`}
    >
      <span className="text-[12px] text-[#64748b]">
        Trang <strong className="text-[#e2e8f0]">{page}</strong> / {totalPages}
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1 || loading}
          className="rounded-lg border border-[#252a38] bg-[#0d0f14] px-3 py-1.5 text-[11px] font-bold text-[#94a3b8] transition-colors hover:border-[#3b82f6] hover:text-[#e2e8f0] disabled:cursor-not-allowed disabled:opacity-40"
        >
          <ChevronLeft size={14} />
        </button>
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages || loading}
          className="rounded-lg border border-[#252a38] bg-[#0d0f14] px-3 py-1.5 text-[11px] font-bold text-[#94a3b8] transition-colors hover:border-[#3b82f6] hover:text-[#e2e8f0] disabled:cursor-not-allowed disabled:opacity-40"
        >
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
};
